const ENDPOINTS = {
  // LOCATION
  create_locations: {
    uri: 'v1/location/bulk-create',
    method: 'POST',
  },
  update_location: {
    uri: 'v1/location/{id}',
    method: 'PUT',
  },
  get_location_by_id: {
    uri: 'v1/location/{id}',
    method: 'GET',
  },
  get_default_tax_product_class: {
    uri: 'v1/location/partner-product-class-tax-rates?include={include}&page={page}&page_size={pageSize}&partner={partner}',
    method: 'GET',
  },
  get_product_classes: {
    uri: 'v1/location/product-classes',
    method: 'GET',
  },
  delete_tax_rate: {
    uri: 'v1/location/product-classes/{id}',
    method: 'DELETE',
  },
  edit_tax_rate: {
    uri: 'v1/location/product-classes/{id}',
    method: 'PUT',
  },
  add_tax_rate: {
    uri: 'v1/location/product-classes',
    method: 'POST',
  },
  edit_tax_rates: {
    uri: 'v1/location/product-classes',
    method: 'PATCH',
  },
  check_existing_locations: {
    uri: 'v1/location/check-existing-locations',
    method: 'POST',
  },
  get_presigned_url: {
    uri: 'v1/file-storage-link',
    method: 'POST',
  },
  list_location_files: {
    uri: 'v1/list-location-files/',
    method: 'GET',
  },
  log: {
    uri: 'vi/log',
    method: 'POST',
  },
  file_storage_link: {
    uri: 'v1/file-storage-link',
    method: 'GET',
  },
};

export type ApiEndpoint = keyof typeof ENDPOINTS;

export { ENDPOINTS };
